import React, { useState, useEffect } from "react";
import "./Forecast.css";
import axios from "axios";
import ForecastDay from "./ForecastDay";

export default function Forecast(props) {
  let [forecast, setForecast] = useState(null);
  let [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [props.coordinates]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }
  function load() {
    let apiKey = "25fad9f7e87157d33dde0f82ab269ee8";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }
  if (loaded) {
    return (
      <div className="Forecast">
        <div className="row">
          <div className="col-2">
            <div className="card">
              <ForecastDay data={forecast[1]} />
            </div>
          </div>
          <div className="col-2">
            <div className="card">
              <ForecastDay data={forecast[2]} />
            </div>
          </div>
          <div className="col-2">
            <div className="card">
              <ForecastDay data={forecast[3]} />
            </div>
          </div>
          <div className="col-2">
            <div className="card">
              <ForecastDay data={forecast[4]} />
            </div>
          </div>
          <div className="col-2">
            <div className="card">
              <ForecastDay data={forecast[5]} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    load();
    return null;
  }
}
